// Useful for converting Array<Maybe<T>> to Array<T>
// e.g. `const arr = maybeArr.filter(isDefined)`

export const isDefined = <T>(t?: T | null): t is T => {
  return t != null
}
